import React from 'react';
import PropTypes from 'prop-types';

import {
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  Grid
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 400
  },
  cardContent: {
    padding: theme.spacing(2),
    '&.MuiCardContent-root:last-child': {
      paddingBottom: theme.spacing(2.5)
    }
  }
}));

const ProductSavings = ({ singleSavings, zeroSavings, dateRange }) => {
  const classes = useStyles();

  return (
    <Card variant='outlined' className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Grid container justify='space-around' alignItems='center'>
          <Grid item xs={12} zeroMinWidth>
            <Box pb={1}>
              <Typography
                variant='subtitle2'
                align='center'
                gutterBottom
                noWrap
              >
                {`Average savings from ${dateRange[0]} to ${dateRange[1]}.`}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={5} zeroMinWidth>
            <Typography
              variant='h6'
              align='center'
              color='textSecondary'
              gutterBottom
              noWrap
            >
              Single&nbsp;Event
            </Typography>
            <Box
              fontSize='h3.fontSize'
              fontWeight={600} // 'fontWeightBold'
              color='primary.main'
              textAlign='center'
              fontFamily={`"Roboto", "Helvetica", "Arial", sans-serif`}
            >
              {`${singleSavings}%`}
            </Box>
          </Grid>
          <Divider orientation='vertical' flexItem />
          <Grid item xs={5} zeroMinWidth>
            <Typography
              variant='h6'
              align='center'
              color='textSecondary'
              gutterBottom
              noWrap
            >
              Zero&nbsp;Event
            </Typography>
            <Box
              fontSize='h3.fontSize'
              fontWeight={600}
              color='primary.main'
              textAlign='center'
              fontFamily={`"Roboto", "Helvetica", "Arial", sans-serif`}
            >
              {`${zeroSavings}%`}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ProductSavings.propTypes = {
  singleSavings: PropTypes.number.isRequired,
  zeroSavings: PropTypes.number.isRequired,
  dateRange: PropTypes.array.isRequired
};

export default ProductSavings;
